import _ from "lodash";
import AfiliadoService from "../provider/Afiliado/AfiliadoService";
import GenerateExcelService from "../provider/GenerateExcel/GenerateExcelService";
import { SUCCESS, ERROR, WARNING } from "../common/Util";
import { CHANGE_APP_PROPS, CHANGE_AFILIADO_PROPS } from "./ActionConstants";

export function actionGetAfiliadosList(
	searchText,
	surname,
	name,
	documentNumber,
	cuil,
	status,
	offset,
	limit
) {
	let docNumber;
	let cuilNumber;
	if (documentNumber)
		docNumber = documentNumber.indexOf("_") === -1 ? documentNumber : null;
	if (cuil) cuilNumber = cuil.indexOf("_") === -1 ? cuil : null;
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetAfiliadoList(
			searchText,
			surname,
			name,
			docNumber,
			cuilNumber,
			status,
			offset,
			limit
		)
			.then(response => {
				dispatch({
					type: CHANGE_AFILIADO_PROPS,
					props: {
						afiliadosList: response ? response : [],
						total: !_.isEmpty(response) ? response[0].cantidad : 0
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(() =>
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				})
			);
	};
}

async function asyncGetAfiliadoList(
	searchText,
	surname,
	name,
	documentNumber,
	cuil,
	status,
	offset,
	limit
) {
	return await AfiliadoService.getAfiliadoList(
		searchText,
		surname,
		name,
		documentNumber,
		cuil,
		status,
		offset,
		limit
	);
}

export function actionCreateAfiliado(values, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncCreateAfiliado(values)
			.then(response => {
				if (response.code) callback(ERROR);
				else {
					dispatch({
						type: CHANGE_AFILIADO_PROPS,
						props: {
							afiliado: response
						}
					});
					callback(SUCCESS);
					dispatch({
						type: CHANGE_APP_PROPS,
						props: {
							loading: false
						}
					});
				}
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
				callback(ERROR);
			});
	};
}

// async function asyncUploadPhoto(photo, path, type, callback) {
// 	let response = await MediaService.uploadImage(photo, path, type, callback);
// 	return response;
// }
async function asyncCreateAfiliado(values) {
	let response = await AfiliadoService.createAfiliado(values);
	return response;
}

export function actionUpdateAfiliado(values, callback) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true }
		});
		asyncUpdateAfiliado(values)
			.then(response => {
				if (response.code) callback(ERROR);
				else {
					let afiliadoList = store().afiliado.afiliadosList;
					const afiliadoIndex = afiliadoList.findIndex(e => {
						return e.id === response.id;
					});
					afiliadoList[afiliadoIndex] = response;
					dispatch({
						type: CHANGE_AFILIADO_PROPS,
						props: {
							afiliado: response,
							afiliadosList: afiliadoList
						}
					});
					callback(SUCCESS);
				}
			})
			.then(() => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: { loading: false }
				});
			});
	};
}

async function asyncUpdateAfiliado(values) {
	return await AfiliadoService.updateAfiliado(values);
}

export function actionDeleteAfiliado(afiliadoId, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDeleteAfiliado(afiliadoId)
			.then(response => {
				//TODO
				if (response.code && response.code === 41215203) {
					callback(WARNING);
				} else {
					callback(SUCCESS);
				}
			})
			.catch(error => {
				callback(ERROR);
			});
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: false
			}
		});
	};
}

async function asyncDeleteAfiliado(afiliadoId) {
	//TODO
	let response = await AfiliadoService.deleteAfiliado(afiliadoId);
	return response;
	// for(let index in listPrueba){
	// 	if(listPrueba[index]._id == afiliadoId){
	// 		listPrueba.splice(index,1);
	// 	}
	// }
	// return afiliadoId;
}

export function actionChangeAfiliadoProps(props) {
	return dispatch => {
		dispatch({
			type: CHANGE_AFILIADO_PROPS,
			props: props
		});
	};
}

export function actionGetContributions(idAffi) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncGetAfiliadoContributions(idAffi)
			.then(response => {
				dispatch({
					type: CHANGE_AFILIADO_PROPS,
					props: {
						contributionsList: response
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}

async function asyncGetAfiliadoContributions(idAffi) {
	let response = await AfiliadoService.getContributions(idAffi);
	return response;
}

export function actionProcessExcel(excelFile, callback) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true,
				loadingText: "Procesando"
			}
		});
		asyncProcessExcel(excelFile)
			.then(response => {
				callback(SUCCESS);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando"
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando"
					}
				});
			});
	};
}

async function asyncProcessExcel(excelFile) {
	var formData = new FormData();
	formData.append("type", "file");
	formData.append("file", excelFile);
	return await AfiliadoService.processExcel(formData);
}

export function actionGenerateAffiliateCard(values, returnDownload) {
	return (dispatch, store) => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: { loading: true, loadingText: "Generando Carnet ..." }
		});
		asyncGenerateAffiliateCard(values)
			.then(response => {
				asyncDownloadFile(response.nombreArchivo)
					.then(resp => {
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
						// Toma la ruta del reporte generado.
						returnDownload(resp);
					})
					.catch(err => {
						console.log("err", err);
						dispatch({
							type: CHANGE_APP_PROPS,
							props: {
								loading: false,
								loadingText: "Cargando ..."
							}
						});
						returnDownload(false);
					});
			})
			.catch(error => {
				console.log("error", error);
				returnDownload(error);
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false,
						loadingText: "Cargando ..."
					}
				});
			});
	};
}

async function asyncGenerateAffiliateCard(values) {
	return await AfiliadoService.generateAffiliateCard(values);
}
async function asyncDownloadFile(fileName) {
	let response = await GenerateExcelService.downloadFile(fileName);
	return response;
}

export function actionDownloadFile(fileName, returnDownload) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncDownloadDorso(fileName).then(response => {
			dispatch({
				type: CHANGE_APP_PROPS,
				props: {
					loading: false
				}
			});
			// Toma la ruta del reporte generado.
			returnDownload(response);
		});
	};
}

async function asyncDownloadDorso(fileName) {
	try {
		let response = await AfiliadoService.downloadFile(fileName);
		return response;
	} catch (error) {
		return error;
	}
}

export async function asyncCheckCuil(cuil) {
	let response = await AfiliadoService.validateCUIL(cuil);
	return response;
}

export function actionCheckContriByCUIL(cuil) {
	return dispatch => {
		dispatch({
			type: CHANGE_APP_PROPS,
			props: {
				loading: true
			}
		});
		asyncCheckCuil(cuil)
			.then(response => {
				dispatch({
					type: CHANGE_AFILIADO_PROPS,
					props: {
						contributionsList: response
					}
				});
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			})
			.catch(error => {
				dispatch({
					type: CHANGE_APP_PROPS,
					props: {
						loading: false
					}
				});
			});
	};
}



// WEBPACK FOOTER //
// ./src/actions/AfiliadoActions.js